import Entities from 'STORE';
import { PushNotificationType } from 'STORE/PushNotifications/PushNotifications.types';

export const clearGroupNotificationByType = (groupId: string, type: PushNotificationType): void => {
  Entities.pushNotifications.clearNotificationByGroupIdAndType(groupId, type);
};
